import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { themeOf } from "@/lib/theme";
import { PhotoGallery } from "@/components/peeps/PhotoGallery";

export function GroupGallery() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  useEffect(() => { api.getGroup(String(id)).then((d) => setGroup(d.group)).catch(() => {}); }, [id]);
  const th = themeOf(group?.theme);
  return (
    <PhotoGallery mode="group" groupId={String(id)} themeColor={th.solid} themeOn={th.on} title={group?.name || "Photos"} subtitle="Group gallery" onBack={() => navigate(-1)} />
  );
}

export function EventGallery() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ev, setEv] = useState(null);
  useEffect(() => { api.getEvent(String(id)).then(setEv).catch(() => {}); }, [id]);
  const th = themeOf(ev?.group?.theme);
  return (
    <PhotoGallery mode="event" groupId={ev?.group?.id} eventId={String(id)} themeColor={th.solid} themeOn={th.on} title={ev?.title || "Photos"} subtitle="Event gallery" onBack={() => navigate(-1)} />
  );
}

export function AllGallery() {
  const navigate = useNavigate();
  const th = themeOf("violet");
  return (
    <PhotoGallery mode="global" themeColor={th.solid} themeOn={th.on} title="All photos" subtitle="Every memory across your groups" onBack={() => navigate(-1)} />
  );
}
